import * as d3 from 'd3';

// Stacked areas: full / delta / cache / fails per second.
export function createDeltaVsFullChart(svgEl) {
  const svg = d3.select(svgEl);
  svg.append('g').attr('class', 'areas');
  svg.append('g').attr('class', 'ax');

  function update(snap) {
    const bounds = svgEl.getBoundingClientRect();
    const W = bounds.width, H = bounds.height;
    svg.attr('viewBox', `0 0 ${W} ${H}`);
    const ts = snap.stats.timeSeries;
    if (!ts.length) return;
    const marginL = 28, marginR = 8, marginT = 8, marginB = 16;
    const keys = ['full', 'delta', 'revalidated', 'cache', 'fails'];
    const colors = { full: '#4ea1ff', delta: '#7ee787', revalidated: '#56d1c9', cache: '#b392f0', fails: '#ff6b6b' };
    const stack = d3.stack().keys(keys)(ts.map((d) => ({
      t: d.t, full: d.full || 0, delta: d.delta || 0, revalidated: d.revalidated || 0, cache: d.cache || 0, fails: d.fails || 0
    })));
    const x = d3.scaleLinear([ts[0].t, ts[ts.length - 1].t + 1], [marginL, W - marginR]);
    const maxY = d3.max(stack[stack.length - 1], (d) => d[1]) || 1;
    const y = d3.scaleLinear([0, maxY], [H - marginB, marginT]);
    const area = d3.area().x((d) => x(d.data.t)).y0((d) => y(d[0])).y1((d) => y(d[1])).curve(d3.curveMonotoneX);

    const g = svg.select('g.areas');
    const layers = g.selectAll('path').data(stack, (_, i) => keys[i]);
    layers.enter().append('path').attr('fill', (_, i) => colors[keys[i]]).attr('opacity', 0.75)
      .merge(layers).attr('d', area);
    layers.exit().remove();

    // Simple legend
    const ax = svg.select('g.ax');
    ax.selectAll('*').remove();
    keys.forEach((k, i) => {
      const xL = marginL + i * 70;
      ax.append('rect').attr('x', xL).attr('y', 2).attr('width', 10).attr('height', 10).attr('fill', colors[k]);
      ax.append('text').attr('x', xL + 14).attr('y', 11).attr('font-size', 10).attr('fill', '#8b949e').text(k);
    });
  }
  return { update };
}
